module.exports = __webpack_public_path__ + "static/media/_MIC2685.image.fb6c4483.png";